/* eslint-disable */
import React from 'react';
import {
  BrowserRouter as Router,
  HashRouter,
  Switch,
  Route
} from 'react-router-dom';
import { observer } from 'mobx-react';

import './App.scss';
import './fonts.css';

import { pages, videos } from './global/constants';

import AppVM from './viewModels/AppVM';
import HomeView from './pages/HomeView';
import QuestionsView from './pages/QuestionsView';

import SOUL from './pages/SOUL';
import SOUL1 from './pages/SOUL1';
import SOUL2 from './pages/SOUL2';
import SOUL3 from './pages/SOUL3';
import SOUL4 from './pages/SOUL4';
import SOUL5 from './pages/SOUL5';
import SOUL6 from './pages/SOUL6';
import SOUL7 from './pages/SOUL7';
import SOUL8 from './pages/SOUL8';

@observer
class App extends React.Component {
  vm = new AppVM();

  render() {
    const { vm } = this;

    return (
      <React.Fragment>
        <Router>
          <Switch>
            <Route path={pages.Questions}>
              <QuestionsView
                isMuted={vm.isMuted}
                setMuted={vm.setMuted}
                getMuted={vm.getMuted}
              />
            </Route>

            <Route path={pages.SOUL}>
              <SOUL />
            </Route>

            <Route path={pages.SOUL1}>
              <SOUL1 />
            </Route>

            <Route path={pages.SOUL2}>
              <SOUL2 />
            </Route>

            <Route path={pages.SOUL3}>
              <SOUL3 />
            </Route>

            <Route path={pages.SOUL4}>
              <SOUL4 />
            </Route>

            <Route path={pages.SOUL5}>
              <SOUL5 />
            </Route>

            <Route path={pages.SOUL6}>
              <SOUL6 />
            </Route>

            <Route path={pages.SOUL7}>
              <SOUL7 />
            </Route>

            <Route path={pages.SOUL8}>
              <SOUL8 />
            </Route>

            <Route path={pages.Home}>
              <HomeView
                isMuted={vm.isMuted}
                setMuted={vm.setMuted}
                getMuted={vm.getMuted}
              />
            </Route>
          </Switch>
        </Router>
      </React.Fragment>
    );
  }
}

export default App;
